import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import format from 'date-fns/format'
import _ from 'lodash'
export default {
    namespaced: true,
    state: {
        questions:[],
        questionssearch: [],
        questionsall:[],
        inputSearch: '',
        selectShow: '',
        countquestion: [],
        category: [],
        schedule: {
            'onetime': 'One-time',
            'weekly': 'Weekly',
            'monthly': 'Monthly',
            'quarterly': 'Quarterly',
            'biannually': 'Bi-annually',
            'yearly': 'Yearly',
        },
        filter:false,
        questionsFilter:[],
        filterData:{},
        questionLoading:false,
        getquestionLoading:false
    },
    mutations: {
        setQuestions(state:any, result:any) {
          
            state.questions = result
        },
        setQuestionsSearch(state:any, result:any) {
            state.questionssearch = result
        }, 
        setQuestionsAll(state: any, result: any) {
            state.questionsall = result
        },
        setinputSearch(state:any,value:any) {
            state.inputSearch = value.value
        },
        setselectShow(state: any, value: any) {
            state.selectShow = value.type
        },
        setCountQuestion(state: any, value: any) {
            state.countquestion = value
        },
        setFilter(state:any, result:any) {
            state.filter = result
        },
        setQuestionsFilter(state:any, result:any) {
            state.questionsFilter = result
        },
        setFilterData(state:any, result:any) {
            state.filterData = result
        },
        setQuestionLoading(state:any, value:any) {
            state.questionLoading = value;
        }, 
        setgetquestionLoading(state:any, value:any) {
            state.getquestionLoading = value;
        },
        
    },
    actions: {
        async getQuestionsCustom({commit,dispatch,rootState,state}:any, user:any){
           
            let optionTo=rootState.question.optionToName
            
            const powerupMaster={
                'ps_critical_thinking':{name:'Critical Thinking'},
                'ps_empathy':{name:'Empathy'},
                'ps_initiative_making':{name:'Initiative Making'},
                'ps_leadership':{name:'Leadership'},
                'ps_self_awareness':{name:'Self Awareness'},
                'ps_optimism':{name:'Optimism'}}
            const category:{ [key: string]: string} = {};
            await firebase.database().ref('category').once('value', snapshot => {
                snapshot.forEach((doc):any => {
                    if(doc.key) category[doc.key] = doc.val().category
                }); 
            });
            const block_questions: { [key: string]: string } = {};
            await firebase.firestore().collection('block_questions').where("company", "==", user.company).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    if (doc.data().quest_id) block_questions[doc.data().quest_id] = doc.id
                });
            });

            firebase.database().ref('questions').orderByChild('company').equalTo(`${user.company}`).once('value', snapshot => {
                const questions:Array<any> = [];
                
                snapshot.forEach((doc):any => {           
                    if(doc.key!='-L1u2Xa5_pSCnitgF3u6' && doc.key!= '-L1u2Xa5_pSCnitgF3u65' && doc.key!='-L1u93FCwY42UOoIhXPC'&& format(new Date(doc.val().endon),"YYYY-MM-DD")>=format(new Date(),"YYYY-MM-DD")){
                        const question = doc.val()
                        question.key = doc.key
                        
                        question.category_name = category[doc.val().category]
                        question.schedule_name = state.schedule[doc.val().repeats]
                        question.powerSkill=question.power_tag?question.power_tag:null
                        if(doc.val().parent == 'Y'){
                            question.type_name = 'Follow-up'
                        }else if(doc.val().type == 'Multiple Choice'){
                            question.type_name = 'Yes/No'
                            if(doc.val().custom_type=='multiple_choice'){
                                question.type_name = 'Multiple Choice'
                            }
                        }else if(doc.val().type == 'Text Area Field'){
                            if(doc.val().power_tag){
                                question.power_skill=`(${powerupMaster[doc.val().power_tag].name})`
                            }else{
                                question.power_skill=''
                            }
                            question.type_name = 'Open-ended'
                        }else{
                            question.type_name = doc.val().type
                        }
                        if(doc.val().parent=="Y"){
                            question.frequency="Follow-up"
                        }else if(doc.val().repeats=="onetime"){
                            question.frequency="One-time"
                        }else if(doc.val().repeats=="weekly"){
                            let frequencyDay=0
                            _.forEach(doc.val().repeat_days, (value)=> {
                                if(value==="Y")
                                 {frequencyDay++}
                            });
                            
                            if (frequencyDay >= 5) {
                                question.frequency="Daily"
                              } else {
                                question.frequency="Weekly"
                              }
                            
                        }else if(doc.val().repeats=="monthly"){
                            if (doc.val().repeat_every > 1) {
                                question.frequency="Bi-monthly"
                            }
                            else{
                                question.frequency="Monthly"
                            }
                        }else if(doc.val().repeats=="quarterly"){
                            if (doc.val().repeat_quarters) {
                                if(doc.val().repeat_quarters.Q1=="Y"&&doc.val().repeat_quarters.Q2=="Y"&&doc.val().repeat_quarters.Q3=="Y"&&doc.val().repeat_quarters.Q4=="Y"){
                                    question.frequency="Quarterly"
                                }else{
                                    question.frequency="Bi-annually"
                                }
                            }
                        }else if(doc.val().repeats=="yearly"){
                            question.frequency="Yearly"
                        }
                        question.block_id = (block_questions[question.key]) ? block_questions[question.key]:''
                        question.block = (block_questions[question.key]) ? 'Y' : 'N'
                        question.block_status = (block_questions[question.key]) ? false : true
                       
                        const optionToName:Array<any>=[]
                        if(!question.teams&&!question.cohorts){
                            optionToName.push("All teams and cohorts")
                        }
                         if(question.teams){
                            question.teams.map(value=>{
                                optionToName.push(optionTo[value])
                            })
                        }
                        if(question.cohorts){
                            question.cohorts.map(value=>{
                                optionToName.push(optionTo[value])
                            })
                        }
                        question.optionToName=optionToName
                       
                        questions.push(question)
                    }
                });
                const counts: Array<any> = [];
                counts.push(_.countBy(questions, 'block'))
                counts[0].all = questions.length
                // console.log('questions',questions)
                commit('setQuestions', _.sortBy(questions, [function(o:any) { return o.question_en; }]))
                commit('setQuestionsSearch', _.sortBy(questions, [function (o: any) { return o.question_en; }]))
                commit('setQuestionsAll', _.sortBy(questions, [function(o:any) { return o.question_en; }]))
                commit('setCountQuestion', counts[0])
                if(state.inputSearch){
                    dispatch('searchQuestions',state.inputSearch)
                }
                if (state.selectShow) {
                    dispatch('selectStatus', state.selectShow)
                }
                if(state.filter==true){
                    dispatch('filtersQuestion', state.filterData)
                }
            }).catch(error => {
                console.log(error)
            });
        },
        searchQuestions({ commit, rootState, dispatch,state}:any,value:string){
            var re = new RegExp(value, 'gi')
            let questions = (state.selectShow) ? state.questions : state.questionsall
            questions=state.filter==true?state.questionsFilter:questions
            if (value) {
                var response = _.filter(questions, (item): any => {
                    if (item.question_en &&item.question_en.match(re)) {
                        return true
                    } else if (item.question &&item.question.match(re)) {
                        return true
                    } 
                    // else if (item.category_name.match(re)) {
                    //     return true
                    // } 
                    else if (item.schedule_name&&item.schedule_name.match(re)) {
                        return true
                    } else if (item.type_name&&item.type_name.match(re)) {
                        return true
                    }
                });
                commit('setQuestionsSearch', response)
                commit('setQuestions', response)
            }else{
                if(state.filter){
               
                    commit('setQuestions', questions)
                }else{
                    dispatch('getQuestionsCustom', rootState.authen.user)
                }
                
            }
        },
        selectStatus({ commit, rootState, dispatch, state }: any, value: string) {
            const questions = (state.inputSearch) ? state.questionssearch : state.questionsall
            if (value != 'all') {
                var response = _.filter(questions, (item): any => {
                    if (item.block.match(value)) {
                        return true
                    }
                });
                commit('setQuestions', response)
            } else {
                dispatch('getQuestionsCustom', rootState.authen.user)
            }
        },
        blockQuestion({ commit, rootState, dispatch }: any, key: any) {
            firebase.firestore().collection('block_questions').where("company", "==", rootState.authen.user.company).where("quest_id", "==", key).get()
            .then(function (querySnapshot) {
                if(querySnapshot.empty){
                    const block_questions: { [key: string]: string } = {};
                    block_questions['quest_id'] = key
                    block_questions['company'] = rootState.authen.user.company
                    block_questions['email_updated'] = rootState.authen.user.email
                    block_questions['createdate'] = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
                    firebase.firestore().collection('block_questions').add(block_questions).then(function(docRef) {
                        /*save logs*/
                        dispatch('authen/addLogs', {
                            company: rootState.authen.user.company,
                            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                            id: docRef.id,
                            table: 'block_questions',
                            status: 'block',
                            user: rootState.authen.user.email
                        }, {root:true}).then(function() {
                            dispatch('getQuestionsCustom',rootState.authen.user)
                        });
                    });
                }else{
                    dispatch('getQuestionsCustom',rootState.authen.user)
                }
            });
        },
        unblockQuestion({ commit, rootState, state, dispatch }: any, key: any) {
            firebase.firestore().collection('block_questions').where("company", "==", rootState.authen.user.company).where("quest_id", "==", key).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    firebase.firestore().collection('block_questions').doc(doc.id).delete().then(()=>{
                        const questions = state.questions;
                        for(const x in questions) {
                            if(questions[x].key === key) {
                                questions[x].block_id = '';
                                questions[x].block = 'N';
                                questions[x].block_status = true;
                                break;
                            }
                        }
                        //commit('setQuestionsAll', questions)
                        // commit('setQuestions', questions)
                    });
                    /*save logs*/
                    dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: key,
                        table: 'block_questions',
                        status: 'unblock',
                        user: rootState.authen.user.email
                    }, {root:true}).then(function() {
                        dispatch('getQuestionsCustom',rootState.authen.user)
                    });
                });
            });
        },
        CreateUpdateQuestion({commit,rootState,state,dispatch}:any,value:any){
           
            
            let optionToType=rootState.question.optionToType
            let team:Array<any>=[]
            let cohorts:Array<any>=[]
            let data: { [key: string]: any; } = {};
            let formData = value.form;
            let alluser=_.find(formData.cascaderTo, function(item){
                return item == 'all_teams_and_cohorts';
            });
            if(!alluser){
                formData.cascaderTo.map(value=>{
                    if(optionToType[value[0]]=='team'){
                        team.push(value[0])
                    }
                    if(optionToType[value[0]]=='cohorts'){
                        cohorts.push(value[0])
                    }
                })
            }
            data = {
                category: formData.category,
                cohorts:cohorts,
                teams:team,
                collect_anonymous_feedback:formData.showResultsInDaily==true?false:true,
                genus: "coins",
                question: formData.questions.th==""?formData.questions.en:formData.questions.th,
                question_en: formData.questions.en,
                questions:formData.questions,
                type: formData.type,
                repeats: formData.frequency,
                status: (formData.status)?formData.status: 'N',
                parent: 'N',
                company: rootState.authen.user.company,
                updated: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                custom_type:formData.custom_type!=undefined? formData.custom_type:formData.type == 'Multiple Choice'?'yes_no':formData.type == 'Multiple Choice(other)'?'multiple_choice':formData.type == 'Scale'?"scale":'open_ended',
                power_tag:formData.type == 'Text Area Field'?(formData.powerSkill?formData.powerSkill:null):null,
                rolling: formData.rolling?formData.rolling:false,
            };
            
            if(!data.questions.th){
                data.questions.th=data.questions.en
            }
            if(formData.type !== 'Text Area Field'){
                if(formData.report_card == true){
                    data.report_card = 'Y'
                    data.report_card_label = formData.report_card_label
                }else{
                    data.report_card = null
                    data.report_card_label = null
                }
            }else{
                data.report_card = null
                data.report_card_label = null
            }
            if(data.collect_anonymous_feedback==false){
                delete data.collect_anonymous_feedback
            }
            if(alluser){
                delete data.cohorts
                delete data.teams
            }
            let choice:any = {};
            let m_choice:any = "";
            let choice_th:any = [];
            let choice_en:any = [];
            let choice_points:any = [];
            let choice_weight:any = [];
            let choice_feeling:any = [];
            let choice_quest_id:any = [];
            if(formData.type == 'Multiple Choice'){
                let standard = {
                    great: 'answered yes',
                    great_num: '70',
                    great_question: '',
                    okay: 'answered yes',
                    okay_num: '50',
                    okay_question: '',
                    notgood: 'answered yes',
                    notgood_num: '50',
                    notgood_question: '',
                };
                _.forEach(formData.options_en, (value,key)=> {
                    // choice_en.push(value.value);
                    //choice_weight.push(value.weight);
                    choice_points.push(formData.coins);
                   
                    choice_quest_id.push(value.question_id);

                });
                // _.forEach(formData.options_th, (value,key)=> {
                //     choice_th.push(value.value);
                // });

                for(const i in rootState.reward.language){
             

                    if(rootState.reward.language[i].code=="en"||rootState.reward.language[i].code=="th"){
                        _.forEach(formData[`options_${rootState.reward.language[i].code}`], (value,key)=> {
                           
                          
                                if(!choice[rootState.reward.language[i].code]){
                                    choice[rootState.reward.language[i].code]=[]
                                }
                                choice[rootState.reward.language[i].code].push(value.value)
                                
                               
                            
                        });
                        if(rootState.reward.language.length==1){
                            if(!choice['th']){
                                choice['th']=[]
                            }
                            choice['th'].push("ใช่")
                            choice['th'].push("ไม่ใช่")
                        }

                    }else{
                        _.forEach(formData.options_YN[`${rootState.reward.language[i].code}`], (value,key)=> {
                          
                          
                                if(!choice[rootState.reward.language[i].code]){
                                    choice[rootState.reward.language[i].code]=[]
                                }
                                choice[rootState.reward.language[i].code].push(value.value)
                            
                        });
                    }
                    
    
                
                }
                choice_weight=formData.feelingY==="Negative"?[0,1]:[1,0];
                choice_feeling=[formData.feelingY,formData.feelingN]
                
                m_choice = {
                    ...choice,
                    points: choice_points,
                    weight: choice_weight,
                    feeling:choice_feeling,
                    quest_id: choice_quest_id,
                }
                data.m_choice = m_choice;
                data.standard = standard;
                data.neutral = formData.feelingY==="Neutral"?"Y":"N";
                data.custom_type='yes_no'
                //data.flip=formData.feelingY==="Negative"?"Y":"N";
            }else if(formData.type==="Multiple Choice(other)"){
                let standard = {
                    great: 'answered yes',
                    great_num: '70',
                    great_question: '',
                    okay: 'answered yes',
                    okay_num: '50',
                    okay_question: '',
                    notgood: 'answered yes',
                    notgood_num: '50',
                    notgood_question: '',
                };
                var neutral=_.filter(
                    formData.options,
                    function (currentObject) {
                        return currentObject.feeling === "Neutral";
                    }
                );
                let firstText = true;
                let text='responded'
                _.forEach(formData.options, (value,i:any)=> {
                    let weight:any
                    
                    if(value.feeling==="Positive")
                    {
                        weight=1
                        if (firstText) {
                            firstText = false;
                            text = text+ " “" + value.en
                        } else {
                            text = text + '” or “' + value.en
                        }
                        
                    }else if(value.feeling==="Neutral"&&neutral.length==formData.options.length){
                        if(i==0 || i=='0')
                        {
                            weight=1
                            text = text+ " “" + value.en
                        }else {
                            weight=0
                        }
                    }
                    else{
                        weight=0
                    }
                    choice_en.push(value.en);
                    choice_weight.push(weight);
                    choice_points.push(formData.coins);
                    choice_th.push(value.th);
                    choice_feeling.push(value.feeling)
                    choice_quest_id.push(value.question_id?value.question_id:'');
                    for(const i in rootState.reward.language){
                        if(value[rootState.reward.language[i].code]){
                            if(!choice[rootState.reward.language[i].code]){
                                choice[rootState.reward.language[i].code]=[]
                            }
                            choice[rootState.reward.language[i].code].push(value[rootState.reward.language[i].code])
                            if(rootState.reward.language.length==1){
                                if(!choice['th']){
                                    choice['th']=[]
                                }
                                choice['th'].push(value[rootState.reward.language[i].code])
                            }
                        }

                    }
                    

                });
             
                m_choice = {
                    ...choice,
                    points: choice_points,
                    weight: choice_weight,
                    feeling:choice_feeling,
                    quest_id: choice_quest_id,
                }
                data.m_choice = m_choice;
                data.standard = standard;
                data.type='Multiple Choice';
                data.neutral = (neutral.length==formData.options.length)?"Y":"N";
                data.custom_type='multiple_choice'
                standard.great=text+"”"
                standard.okay=text+"”"
                standard.notgood=text+"”"
            }else if(formData.type == 'Scale'){
                let standard={
                    great : "average rating for the work-life balance in your team",
                    great_num : "7.5",
                    great_question : "",
                    notgood : "average rating for the work-life balance in your team",
                    notgood_num : "5",
                    notgood_question : "",
                    okay : "average rating for the work-life balance in your team",
                    okay_num : "5",
                    okay_question : ""
                  }
                data.less_txt=formData.less_txts.th?formData.less_txts.th:formData.less_txts.en;
                data.less_txt_en=formData.less_txts.en;
                data.less_txts=formData.less_txts;
                data.max_txt=formData.max_txts.th?formData.max_txts.th:formData.max_txts.en;
                data.max_txt_en=formData.max_txts.en;
                data.max_txts=formData.max_txts
                data.points = formData.coins;
                data.neutral = "N";
                data.standard = standard;
                data.custom_type='scale'
               
                
            }else{
                data.points = formData.coins;
                data.neutral = "N";
                data.custom_type='open_ended'
            }


            if(formData.frequency == 'onetime'){
                data.starton = format(formData.schedule, 'DD/MM/YYYY');
            }else if(formData.frequency !== 'Follow-up'){
                let repeat_days:any = "";
                repeat_days = {
                    Sun: (formData.dayofweek && formData.dayofweek == 'sunday')?"Y":"N",
                    Mon: (formData.dayofweek && formData.dayofweek == 'monday')?"Y":"N",
                    Tue: (formData.dayofweek && formData.dayofweek == 'tuesday')?"Y":"N",
                    Wed: (formData.dayofweek && formData.dayofweek == 'wednesday')?"Y":"N",
                    Thu: (formData.dayofweek && formData.dayofweek == 'thursday')?"Y":"N",
                    Fri: (formData.dayofweek && formData.dayofweek == 'friday')?"Y":"N",
                    Sat: (formData.dayofweek && formData.dayofweek == 'saturday')?"Y":"N",
                }
                data.repeat_days = repeat_days;
                data.starton = format(new Date(), 'DD/MM/YYYY');
            }
            if (formData.frequency == 'monthly') {
                let repeat_weeks:any = "";
                repeat_weeks = {
                    week1: (formData.schedule == 'week1')?"Y":"N",
                    week2: (formData.schedule == 'week2')?"Y":"N",
                    week3: (formData.schedule == 'week3')?"Y":"N",
                    week4: (formData.schedule == 'week4')?"Y":"N",
                    week5: "N"
                }
                data.repeat_weeks = repeat_weeks;
            }else if(formData.frequency == 'quarterly'){
                let scheduleQuarter = formData.schedule.split("_");
                let repeat_weeks:any = "";
                repeat_weeks = {
                    week1: (scheduleQuarter[1] == 'week1')?"Y":"N",
                    week2: (scheduleQuarter[1] == 'week2')?"Y":"N",
                    week3: (scheduleQuarter[1] == 'week3')?"Y":"N",
                    week4: (scheduleQuarter[1] == 'week4')?"Y":"N",
                    week5: "N"
                }
                data.repeat_weeks = repeat_weeks;
                data.repeat_quarter=scheduleQuarter[0]
                data.repeat_quarters = {
                    Q1:'Y',
                    Q2:'Y',
                    Q3:'Y',
                    Q4:'Y',
                }
            }else if(formData.frequency == 'biannually'){
                let scheduleQuarter = formData.schedule.split("_");
                let repeat_weeks:any = '';
                repeat_weeks = {
                    week1: (scheduleQuarter[1] == 'week1')?'Y':'N',
                    week2: (scheduleQuarter[1] == 'week2')?'Y':'N',
                    week3: (scheduleQuarter[1] == 'week3')?'Y':'N',
                    week4: (scheduleQuarter[1] == 'week4')?'Y':'N',
                    week5: (scheduleQuarter[1] == 'week5')?'Y':'N',
                }
                data.repeat_weeks = repeat_weeks;
                data.repeat_quarter=scheduleQuarter[0]
                data.repeat_quarters = {
                    Q1:(scheduleQuarter[2] == 'q1')?'Y':'N',
                    Q2:(scheduleQuarter[2] == 'q2')?'Y':'N',
                    Q3:(scheduleQuarter[3] == 'q3')?'Y':'N',
                    Q4:(scheduleQuarter[3] == 'q4')?'Y':'N',
                }
            }else if(formData.frequency == 'yearly'){
                let scheduleQuarter = formData.schedule.split("_");
                let repeat_weeks:any = '';
                repeat_weeks = {
                    week1: (scheduleQuarter[1] == 'week1')?'Y':'N',
                    week2: (scheduleQuarter[1] == 'week2')?'Y':'N',
                    week3: (scheduleQuarter[1] == 'week3')?'Y':'N',
                    week4: (scheduleQuarter[1] == 'week4')?'Y':'N',
                    week5: (scheduleQuarter[1] == 'week5')?'Y':'N',
                }
                data.repeat_weeks = repeat_weeks;
                data.repeat_months=scheduleQuarter[0]
            }else if(formData.frequency == 'Follow-up'){
                data.parent='Y'
                delete data.repeats
                delete data.report_card
                delete data.report_card_label
                delete data.rolling
                
            }




            if(formData.frequency == 'weekly' || formData.frequency == 'monthly'){
                data.repeat_every = "1"
            }
            for(const i in rootState.reward.language){
                if(!data.questions[rootState.reward.language[i].code]){
                    data.questions[rootState.reward.language[i].code]= data.questions.en?data.questions.en:''
                } 
            }

    
            let newId:any = "";
            let status = "";
            if(formData.key){
                newId = formData.key
                status = 'edit';
                
                firebase.database().ref(`questions/${newId}`).update(data);
            }else{
                newId = firebase.database().ref('questions').push().key;
                status = 'add';
                let insert = {};
                insert[newId] = data;
                 //console.log('insert',insert)
                firebase.database().ref('questions').update(insert);
            }
            // console.log('newId',newId)
            
            /*save logs*/
            dispatch('authen/addLogs', {
                company: rootState.authen.user.company,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                id: newId,
                table: 'questions',
                status: status,
                user: rootState.authen.user.email
            }, {root:true}).then(function() {
                dispatch('getQuestionsCustom',rootState.authen.user)
            });
        },
        deleteQuestion({commit,rootState,dispatch}:any,id:any){
            if(id){
                firebase.database().ref('questions').child(id).remove();
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: id,
                    table: 'questions',
                    status: 'remove',
                    user: rootState.authen.user.email
                }, {root:true}).then(function() {
                    dispatch('getQuestionsCustom',rootState.authen.user)
                });
            }
        },
        filtersQuestion({ commit, rootState, dispatch,state}:any,value:any){
            commit('setQuestionLoading', true)
            const questionsData =(state.inputSearch) ? state.questionssearch : state.questionsall
            commit('setFilter',true)
            commit('setFilterData',{questionstype:value.questionstype,powerskill:value.powerskill,dimension:value.dimension})
            let questions:any=[]
            const _questions:any=[]
            let countdata=0
            if(value.questionstype.length>0){
                countdata=countdata+1
                value.questionstype.map(v=>{
                    const filterqustion=_.filter(questionsData,(o)=>{return o.type_name==v})
                    
                    _questions.push(...filterqustion)
                })

            }
            if(value.dimension.length>0){
                countdata=countdata+1
                value.dimension.map(v=>{
                    const filterqustion=_.filter(questionsData,(o)=>{return o.category_name==v})
                    
                    _questions.push(...filterqustion)
                })

            }

            if(value.powerskill.length>0){
                countdata=countdata+1
                value.powerskill.map(v=>{
                    const filterqustion=_.filter(questionsData,(o)=>{return o.power_skill==`(${v})`})
                    
                    _questions.push(...filterqustion)
                })

            }
            if(value.powerskill.length==0&&value.questionstype.length==0&&value.dimension.length==0){
                commit('setFilter',false)
                questions=questionsData
            }

            let arr = _.groupBy(_questions, function (b) {
                return b.key;
              });
              for(let key in arr){
                if(arr[key].length==countdata){
                    questions.push(arr[key][0])
                }
              }
            commit('setQuestions', _.sortBy(questions, [function(o:any) { return o.question_en; }]))
            commit('setQuestionsFilter', _.sortBy(questions, [function(o:any) { return o.question_en; }]))
            commit('setQuestionLoading', false)



        },
        async getOpenai({ commit, rootState, dispatch,state}:any,value:any){
            // console.log('questions',value.questions)
            // console.log('language',value.languages)
            commit('setgetquestionLoading',true)
            let length_lang=_.clone(value.languages).length
            let languages=''
            let count=0
            const materlanguage=(await firebase.database().ref(`/language`).once('value')).val()
            for(const i in value.languages){
                
                count++
                if(materlanguage[value.languages[i].code]){
                    
                    if(length_lang==count){
                        languages=languages+materlanguage[value.languages[i].code].name

                    }else{
                        languages=languages+materlanguage[value.languages[i].code].name+","
                    }
                    

                }
                // languages
                
            }
         
            var axios = require('axios');
            let text=`# Role\nYou are a question designer for a daily pulse survey tool called Happily.ai that are tailored to assess and develop specific workplace skills, employee engagement, and organizational health. Focus on creating questions that are clear, concise, and conducive to regular conversation.\n\nIf you're given background and context about the company, consider it when designing the question.\n# Question Types\n## Open-ended\nOpen-ended questions should target developing one of the following skills: Leadership, Critical Thinking, Initiative-making, Self-awareness, Empathy, or Optimism. It is advisable for the question to be phrased forward-looking or reflect on recent experiences, encourage reflective thinking, and be suitable for recurring discussions.\n## Multiple Choice\nFor multiple choice questions, provide the multiple choice options. Each option label should be 1-3 words in length. Follow best practices (e.g., 5-point Likert scale). Specify if each option is positive, neutral, or negative. \n# Question Requirements\n## Engagement Dimension\nFor all of the questions, select which employee engagement dimension it belongs to from this list: Happiness, Recognition, Feedback, Personal Growth, Introspection, Satisfaction, Ambassadorship, Company Alignment, Wellness, Relationship with Manager, Relationship with Colleagues.\n## Frequency\nRecommend the frequency that this question should be asked depending on how useful it would be to gather insights or have conversions inspired by this question. Keep in mind that there are over 450 questions in our library scheduled in a way that there should be no more than 4-5 questions daily.\n\nExamples of how schedules should be structured:\n- If Weekly: Select Day Of Week\n- If Monthly: Select Day of Week, Week of Month (1-5)\n- If Quarterly: Select Day of Week, Week of Month (1-5), Month of Quarter (1-3)\n- If Biannually: Select Day of Week, Week of Month (1-5), Month of Quarter (1-3), Select Q1 & Q3 or Q2 & Q4\n- If Yearly: Select Day of Week, Week of Month (1-5), Month of Year (1-12)\n\n###dayOfWeek Preference by Engagement Dimension\n- Monday: Happiness, Company Alignment\n- Tuesday: Feedback, Personal Growth\n- Wednesday: Relationship with Colleagues, Ambassadorship\n- Thursday: Relationship with Manager, Recognition\n- Friday: Wellness, Satisfaction\n\n## Reward\nSelect the number of coins to be awarded to answer this question. Easy and straightforward multiple-choice questions should earn 1 coin, and the number of coins can expand to 5 depending on how much cognitive effort is required to answer the question effectively.  \n## Tone\nFriendly, thoughtful, and conversational.\n## Length\nEach question should not exceed 20 words.\n## Quality\nRefine and improve the question for clarity and ensure that, if multiple-choice, the options are distinct enough to be insightful (e.g., \"Extremely Well\" and \"Very Well\" are not distinct enough)\n\n# User Input\n{User Input}\n\n# Required Languages\n{Languages}\n\n# Response\nBased on the information and context provided, 1. Decide if the questions should be multiple-choice or open-ended depending on whether a quantitative measurement or qualitative feedback is more appropriate and insightful 2. Generate the question and its attributes as a JSON object with the structure as specified.\n\n{\n  \"type\": \"object\",\n  \"properties\": {\n    \"question\": {\n      \"type\": \"object\",\n      \"patternProperties\": {\n        \"^[a-z]{2}(-[A-Z]{2})?$\": { \"type\": \"string\" }\n      },\n      \"minProperties\": 1\n    },\n    \"options\": {\n      \"type\": \"array\",\n      \"items\": {\n        \"type\": \"object\",\n        \"properties\": {\n          \"content\": {\n            \"type\": \"object\",\n            \"patternProperties\": {\n              \"^[a-z]{2}(-[A-Z]{2})?$\": { \"type\": \"string\" }\n            },\n            \"minProperties\": 1\n          },\n          \"sentiment\": {\n            \"enum\": [\"Positive\", \"Neutral\", \"Negative\"]\n          }\n        },\n        \"required\": [\"content\", \"sentiment\"]\n      }\n    },\n    \"type\": {\n      \"type\": \"object\",\n      \"properties\": {\n        \"dimension\": { \"type\": \"string\" },\n        \"questionType\": { \"enum\": [\"Open-ended\", \"Multiple Choice\"] }\n      },\n      \"required\": [\"dimension\", \"questionType\"]\n    },\n    \"reward\": {\n      \"type\": \"integer\",\n      \"minimum\": 1,\n      \"maximum\": 5\n    },\n    \"frequency\": {\n      \"enum\": [\"One-time\", \"Weekly\", \"Monthly\", \"Quarterly\", \"Biannually\", \"Yearly\"]\n    },\n    \"schedule\": {\n      \"type\": \"object\",\n      \"properties\": {\n        \"dayOfWeek\": {\n          \"enum\": [\"Monday\", \"Tuesday\", \"Wednesday\", \"Thursday\", \"Friday\", \"Saturday\", \"Sunday\"]\n        },\n        \"weekOfMonth\": {\n          \"type\": \"integer\",\n          \"minimum\": 1,\n          \"maximum\": 5\n        },\n        \"monthOfQuarter\": {\n          \"type\": \"integer\",\n          \"minimum\": 1,\n          \"maximum\": 3\n        },\n        \"monthOfYear\": {\n          \"type\": \"integer\",\n          \"minimum\": 1,\n          \"maximum\": 12\n        },\n        \"quarterPair\": {\n          \"enum\": [\"Q1Q3\", \"Q2Q4\"]\n        }\n      },\n      \"required\": [\"dayOfWeek\"],\n      \"allOf\": [\n        {\n          \"if\": {\n            \"properties\": { \"frequency\": { \"enum\": [\"Weekly\"] } }\n          },\n          \"then\": {\n            \"properties\": { \"schedule\": { \"required\": [\"dayOfWeek\"] } }\n          }\n        },\n        {\n          \"if\": {\n            \"properties\": { \"frequency\": { \"enum\": [\"Monthly\"] } }\n          },\n          \"then\": {\n            \"properties\": { \"schedule\": { \"required\": [\"dayOfWeek\", \"weekOfMonth\"] } }\n          }\n        },\n        {\n          \"if\": {\n            \"properties\": { \"frequency\": { \"enum\": [\"Quarterly\"] } }\n          },\n          \"then\": {\n            \"properties\": { \"schedule\": { \"required\": [\"dayOfWeek\", \"weekOfMonth\", \"monthOfQuarter\"] } }\n          }\n        },\n        {\n          \"if\": {\n            \"properties\": { \"frequency\": { \"enum\": [\"Biannually\"] } }\n          },\n          \"then\": {\n            \"properties\": { \"schedule\": { \"required\": [\"dayOfWeek\", \"weekOfMonth\", \"monthOfQuarter\", \"quarterPair\"] } }\n          }\n        },\n        {\n          \"if\": {\n            \"properties\": { \"frequency\": { \"enum\": [\"Yearly\"] } }\n          },\n          \"then\": {\n            \"properties\": { \"schedule\": { \"required\": [\"dayOfWeek\", \"weekOfMonth\", \"monthOfYear\"] } }\n          }\n        }\n      ]\n    }\n  },\n  \"required\": [\"question\", \"type\", \"reward\", \"frequency\", \"schedule\"]\n}\n`
            text=text.replace("{User Input}", value.questions);
            text=text.replace("{Languages}", languages);
        
            return await axios.post('https://api.openai.com/v1/chat/completions', {
                model: "gpt-4o",
                messages:[
                    {
                        "role": "system",
                        "content": [
                          {
                            "text": "You are an expert question designer and UX copywriter",
                            "type": "text"
                          }
                        ]
                      },
                      {
                        "role": "user",
                        "content": [
                          {
                            "type": "text",
                            "text": text
                          }
                        ]
                      }
                ],
                  response_format: {
                    "type": "json_object"
                  },
                  temperature: 0.1,
                  max_completion_tokens: 2048,
                  top_p: 1,
                  frequency_penalty: 0,
                  presence_penalty: 0
            },
            {
                headers: {
                    'Authorization': 'Bearer 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', 
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                const json = response.data;
                    //  console.log("json",json)
      
                if(json && json.choices && json.choices[0] && json.choices[0].message && json.choices[0].message.content){
                    let fixedJsonString =json.choices[0].message.content;
                    
                    let message;
                    try {
                        message = JSON.parse(fixedJsonString);
                        if(message){
                            //console.log('message',message)
                            const newId = firebase.database().ref('questions').push().key;
                            message.key=newId
                            commit('setgetquestionLoading',false)
                            return message
                        }
                        
                    } catch (error) {
                        console.log("error",error)
                     
                    }
                }
            })
            .catch(function (error) {
                console.log('error',error);
            });

        }
    },
    getters: {
        questions : (state:any) => {
            return state.questions
        },
        countquestion: (state: any) => {
            return state.countquestion
        },
        inputSearch: (state:any) => {
            return state.inputSearch
        },
        qusetioncustomAll: (state: any) => {
            return state.questionsall
        },
        getquestionLoading: (state: any) => {
            return state.getquestionLoading
        }

    }
  }